import React from 'react'
import Arrow from '../components/Arrow'
import PageItem from './PageItem'
import generatePagination from './paginationGenerator'
import paginationStyles from './Pagination.module.css'
import { UpdateSearchParams } from '../../types/List'
import { Pagination } from '../../types/Pagination'

type PageListProps = {
  updateSearchParams: UpdateSearchParams
  pagination: Pagination
}
type PrevNextPageProps = {
  updateSearchParams: UpdateSearchParams
  page?: Pagination
  type: 'prev' | 'next'
}

export function CustomPage (props: PrevNextPageProps) {
  if (!props.page) {
    return null
  }
  return (
    <PageItem
      type={props.type}
      updateSearchParams={props.updateSearchParams}
      pagination={props.page}
    >
      <Arrow direction={props.type === 'prev' ? 'left' : 'right'} />
    </PageItem>
  )
}

function findPage (pages: Pagination[], pageToFind: number) {
  return pages.find(page => page.current === pageToFind)
}

export default function PageList (props: PageListProps) {
  const { updateSearchParams, pagination } = props
  const pages = generatePagination(pagination)
  const prevPage = findPage(pages, pagination.current - 1)
  const nextPage = findPage(pages, pagination.current + 1)
  return (
    <div className={paginationStyles.root}>
      <CustomPage
        updateSearchParams={updateSearchParams}
        type='prev'
        page={prevPage}
      />
      {pages.map(page => {
        if (!page.block) {
          return (
            <span key={page.current} className={paginationStyles.ellipsis}>
              ...
            </span>
          )
        }
        return (
          <PageItem
            className={paginationStyles[page.block]}
            currentPage={pagination.current}
            key={page.current}
            updateSearchParams={updateSearchParams}
            pagination={page}
            type='page'
          />
        )
      })}
      <CustomPage
        updateSearchParams={updateSearchParams}
        type='next'
        page={nextPage}
      />
    </div>
  )
}
